import React, { useEffect,useState  } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineDashboard } from "react-icons/ai";
import { BsBoxSeam, BsGrid, BsCardList, BsTag, BsCpu, BsCapsule, BsCart3 } from "react-icons/bs";
import { FaUserMd, FaHospital, FaStethoscope, FaClinicMedical, FaProcedures, FaCalendarCheck, FaUsersCog } from "react-icons/fa";
import { MdOutlineImage, MdOutlineSettings, MdOutlineArticle, MdOutlineCategory,MdOutlineCalendarMonth,MdOutlineHealthAndSafety, MdOutlineMail, MdOutlineRateReview } from "react-icons/md";
import { IoCall } from "react-icons/io5"; 
import "./styles/Leftmenu.css";
import "../styles/global.css";

const Leftmenu = () => {

    
    const location = useLocation(); 
    const [configId, setConfigId] = useState(null);
    const [company, setCompanyId] = useState(null); 
    useEffect(() => {
        if(localStorage.getItem('config_id')!=null){
            setConfigId(localStorage.getItem('config_id')); 
        }
        setCompanyId(localStorage.getItem('company_name')); 
    }, []); 
    return (
     <div className="sidebar-left">
        <div className="sidebar-slide h-100" data-simplebar>
     
            <div id="sidebar-menu"> 
                <ul className="left-menu list-unstyled" id="side-menu">
                    <li>
                        <Link to="/dashboard" className={`nav-item nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}>
                            <AiOutlineDashboard />
                            <span>Dashboard</span>
                    </Link> 
                    </li>
                    <li className="menu-title">Products</li>
                    <li>
                        <Link to="/category" className={`nav-item nav-link ${location.pathname === '/category' ? 'active' : ''}`}>
                        <BsGrid />
                            <span>Category</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/subcategory" className={`nav-item nav-link ${location.pathname === '/subcategory' ? 'active' : ''}`}>
                        <BsCardList />
                            <span>Sub Category</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/brand" className={`nav-item nav-link ${location.pathname === '/brand' ? 'active' : ''}`}>
                        <BsTag />
                            <span>Brand</span>
                        </Link>
                    </li>
                
                    
                    <li>
                        <Link to="/model" className={`nav-item nav-link ${location.pathname === '/model' ? 'active' : ''}`}>
                        <BsCpu />
                            <span>Model</span>
                        </Link>
                    </li>
                     <li>
                        <Link to="/medicinetype" className={`nav-item nav-link ${location.pathname === '/medicinetype' ? 'active' : ''}`}>
                        <BsCapsule />
                            <span>Medicine Type</span>
                        </Link>
                    </li>
                    
                    <li>
                        <Link to="/product" className={`nav-item nav-link ${location.pathname === '/product' ? 'active' : ''}`}>
                        <BsBoxSeam />
                            <span>Product</span>
                        </Link>
                    </li>
                     <li>
                        <Link to="/coupon" className={`nav-item nav-link ${location.pathname === '/coupon' ? 'active' : ''}`}>
                        <BsBoxSeam />
                            <span>Coupon</span>
                        </Link>
                    </li>
                     <li>
                        <Link to="/orderlist" className={`nav-item nav-link ${location.pathname === '/orderlist' ? 'active' : ''}`}>
                        <BsCart3 />
                            <span>Order List</span>
                        </Link>
                    </li>
                    <li className="menu-title">Doctors</li>
                    <li>
                        <Link to="/department" className={`nav-item nav-link ${location.pathname === '/department' ? 'active' : ''}`}>
                        <FaHospital />
                            <span>Doctor Department</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/specialization" className={`nav-item nav-link ${location.pathname === '/specialization' ? 'active' : ''}`}>
                        <FaStethoscope />
                            <span>Doctor Specialization</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/clinic" className={`nav-item nav-link ${location.pathname === '/clinic' ? 'active' : ''}`}>
                        <FaClinicMedical />
                            <span>Clinic</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/treatment" className={`nav-item nav-link ${location.pathname === '/treatment' ? 'active' : ''}`}>
                        <FaProcedures />
                            <span>Treatment</span>
                        </Link>
                    </li>
                     <li>
                        <Link to="/doctor" className={`nav-item nav-link ${location.pathname === '/doctor' ? 'active' : ''}`}>
                        <FaUserMd />    
                            <span>Doctor</span>
                        </Link>
                    </li>
                     <li>
                        <Link to="/doctor-bookings" className={`nav-item nav-link ${location.pathname === '/doctor-bookings' ? 'active' : ''}`}>
                        <FaCalendarCheck />    
                            <span>Doctor Bookings</span>
                        </Link>
                    </li>
                    <li className="menu-title">Others</li>
                    <li>
                        <Link to="/users" className={`nav-item nav-link ${location.pathname === '/users' ? 'active' : ''}`}>
                        <FaUsersCog />
                            <span>User Management</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/banner" className={`nav-item nav-link ${location.pathname === '/banner' ? 'active' : ''}`}>
                        <MdOutlineImage />
                            <span>Banner</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/contact-enquiry" className={`nav-item nav-link ${location.pathname === '/contact-enquiry' ? 'active' : ''}`}>
                        <MdOutlineMail />
                            <span>Contact Enquiry</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/blogcategory" className={`nav-item nav-link ${location.pathname === '/blogcategory' ? 'active' : ''}`}>
                        <MdOutlineCategory />
                            <span>Blog Category</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/blog" className={`nav-item nav-link ${location.pathname === '/blog' ? 'active' : ''}`}>
                        <MdOutlineArticle />
                            <span>Blog </span>
                        </Link>
                    </li>
                     <li>
                        {/* FIXED: was checking '/doctor-bookings' instead of '/settings' */}
                        <Link to="/settings/1" className={`nav-item nav-link ${location.pathname.startsWith('/settings') ? 'active' : ''}`}>
                        <MdOutlineSettings />    
                            <span>Settings</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/reviews" className={`nav-item nav-link ${location.pathname.startsWith('/reviews') ? 'active' : ''}`}>
                        <MdOutlineRateReview />
                            <span>Reviews</span>
                        </Link>
                    </li>
                    <li>
                    <Link to="/events" className={`nav-item nav-link ${location.pathname.startsWith('/events') ? 'active' : ''}`}>
                            <MdOutlineCalendarMonth />
                            <span>Events</span>
                        </Link>
                    </li>
                    <li>
                    <Link to="/camps" className={`nav-item nav-link ${location.pathname.startsWith('/camps') ? 'active' : ''}`}>
                            <MdOutlineCalendarMonth />
                            <span>Camps</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/awareness-days" className={`nav-item nav-link ${location.pathname.startsWith('/awareness-days') ? 'active' : ''}`}>
                            <MdOutlineHealthAndSafety />
                            <span>Awareness Days</span>
                        </Link>
                    </li>
 
                     
                    <li>
                        <Link to="/contact"  className={`nav-item nav-link ${location.pathname.startsWith('/contact') ? 'active' : ''}`} ><IoCall /> <span>Contact</span></Link>
                    </li>
                </ul>
            </div> 
        </div>
    </div>
   
    );
};

export default Leftmenu;